import { VerificationSubmitter } from '@se-po/se-household-setup-feature-verification'

export class DocsVerificationSubmitter implements VerificationSubmitter {
  public submitting = false
  public unknownError = false
  public resendAccountActivated = false
  public resendSuccess = false

  signIn(formEl: HTMLFormElement): void {
    console.log('formEl', formEl)
    alert('This will submit to the sign in page with the selected email prefilled')
    this.submitting = false
  }

  resend(accountUuid: string): void {
    alert('This will attempt to resend the verification email')
    this.submitting = false
  }

  reset(): void {
    alert('This will direct back to account')
    this.submitting = false
  }
}
